export default __webpack_public_path__ + "static/media/paymaya.62ea09e8.png";